export const EMPTY_CELL_VALUE = <span></span>;
